



























import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import { useWOVNio } from '~/composables/wovn/useWOVNio';
import { CATCHCOPY } from '~/constants/products';
import { ProductSetItems } from '~/types/modules/product';
import { DisplayLang } from '~/enums';

export default defineComponent({
  components: {
    AppImage,
  },
  props: {
    leafletInfo: {
      type: Array as PropType<ProductSetItems[]>,
      required: true,
    },
  },
  setup(props) {
    const { currentLang } = useWOVNio();

    // 子商品情報をリーフレット用に整形する
    const leafletDetails = computed(() => {
      return props.leafletInfo.map((leaflet) => {
        const { id, langs, main_image_url, attributes } = leaflet;

        return {
          id,
          name:
            currentLang.value.code === DisplayLang.JA
              ? langs.find((lang) => lang?.id === 'ja')?.name
              : langs.find((lang) => lang?.id === 'en')?.name,
          image: main_image_url,
          explanation: attributes.find((attribute) => attribute.key === CATCHCOPY)?.value || '',
        };
      });
    });

    return {
      leafletDetails,
    };
  },
});
